import Button from "./Button";

export default function Modal({
  title,
  children,
  onClose,
  onConfirm,
  confirmLabel = "Confirm",
  danger = false,
  confirmDisabled = false,
}) {
  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2 className="h2">{title}</h2>
        <div style={{ marginTop: 12, color: danger ? "var(--color-danger)" : "var(--color-steel)" }}>{children}</div>
        <div className="row" style={{ marginTop: 18, justifyContent: "flex-end" }}>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          {onConfirm ? (
            <Button variant={danger ? "danger" : "primary"} onClick={onConfirm} disabled={confirmDisabled}>
              {confirmLabel}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
